/**
 * This source code is quoted from rc-util.
 * homepage: https://github.com/react-component/util
 */
import React from 'react';
export default function toArray(children) {
  var ret = [];
  React.Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-core/src/toArray.js